"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmListItem = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Thumbnail_1 = require("../Thumbnail");
exports.SmListItem = react_1.default.forwardRef((_a, ref) => {
    var { label, text, imageURL, imageALT, components, disabled, className } = _a, props = __rest(_a, ["label", "text", "imageURL", "imageALT", "components", "disabled", "className"]);
    const [isFocused, setFocused] = react_1.default.useState(false);
    const prefix = react_1.default.useMemo(() => {
        if (components === null || components === void 0 ? void 0 : components.prefix) {
            return react_1.default.createElement("div", { className: "c-list__prefix" }, components.prefix);
        }
        if (imageURL) {
            return (react_1.default.createElement("div", { className: "c-list__prefix" },
                react_1.default.createElement(Thumbnail_1.SmThumbnail, { size: "small", src: imageURL, alt: imageALT })));
        }
        return null;
    }, [components === null || components === void 0 ? void 0 : components.prefix, imageURL, imageALT]);
    const listItemClassnames = (0, classnames_1.default)('c-list__item', { '-focusable': props.onClick, '-disabled': disabled }, className);
    return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    react_1.default.createElement("li", Object.assign({}, props, { role: props.onClick ? 'option' : 'listitem', "aria-selected": props.onClick && isFocused, "aria-disabled": disabled, onFocus: (e) => {
            var _a;
            if (!disabled) {
                setFocused(true);
                (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        }, onBlur: (e) => {
            var _a;
            if (!disabled) {
                setFocused(false);
                (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        }, onClick: (e) => {
            var _a;
            if (!disabled) {
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        }, className: listItemClassnames, 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: props.onClick ? 0 : -1, ref: ref }),
        react_1.default.createElement("div", { className: "c-list__main" },
            prefix,
            react_1.default.createElement("div", { className: "c-list__content" },
                label && react_1.default.createElement("span", { className: "c-list__contentLabel" }, label),
                react_1.default.createElement("span", { className: "c-list__contentText" }, text))),
        (components === null || components === void 0 ? void 0 : components.extra) && (react_1.default.createElement("div", { className: "c-list__extra" }, components.extra))));
});
//# sourceMappingURL=SmListItem.js.map